import { render } from "./CorsiDataTable.vue?vue&type=template&id=bddda1ce&scoped=true"
import script from "./CorsiDataTable.vue?vue&type=script&lang=js"
export * from "./CorsiDataTable.vue?vue&type=script&lang=js"

import "./CorsiDataTable.vue?vue&type=style&index=0&id=bddda1ce&scoped=true&lang=css"

import exportComponent from "/var/www/html/levante_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bddda1ce"]])

export default __exports__